import React from "react"

const CATEGORY_CONFIG = {
  structured: {
    label: "STRUCTURED",
    description: "Querying company data",
    color: "#1976D2",
    bg: "#E3F2FD",
  },
  analytical: {
    label: "ANALYTICAL",
    description: "Comparing across dataset",
    color: "#2E7D32",
    bg: "#E8F5E9",
  },
  narrative: {
    label: "NARRATIVE",
    description: "Reading company report",
    color: "#407775",
    bg: "#DAECEC",
  },
  novel: {
    label: "NOVEL",
    description: "Synthesizing insights",
    color: "#B8860B",
    bg: "#FFF8E1",
  },
}

const ClassificationBadge = ({ category, confidence }) => {
  const config = CATEGORY_CONFIG[category] || CATEGORY_CONFIG.novel

  return (
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        padding: "3px 10px",
        borderRadius: "12px",
        backgroundColor: config.bg,
        marginBottom: "8px",
      }}
    >
      <span
        style={{
          fontSize: "10px",
          fontWeight: "700",
          color: config.color,
          letterSpacing: "0.5px",
        }}
      >
        {config.label}
      </span>
      <span style={{ fontSize: "10px", color: "#707070" }}>
        {config.description}
      </span>
      {confidence != null && (
        <span
          style={{
            fontSize: "9px",
            color: "#999",
            marginLeft: "2px",
          }}
        >
          ({Math.round(confidence * 100)}%)
        </span>
      )}
    </div>
  )
}

export default ClassificationBadge
